/**
 * ReportTransactionSeed entity class
 *
 * Аналог ReportFinancialSeed, но с url /report/transaction/*
 */
import moment from 'moment/moment'

/* @ngInject */
export default function ReportTransactionSeedFactory ($http, $injector, Entity, onOffMixin, alertLiteSvc) {
  function ReportTransactionSeed () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ReportTransactionSeed.prototype = Object.create(Entity.prototype)
  ReportTransactionSeed.prototype.constructor = ReportTransactionSeed

  Object.assign(ReportTransactionSeed.prototype, {
    _fields: {
      autoPay: false,
      fields: [String],
      firstActivation: false,
      from: moment,
      to: moment,
      organizations: ['Network'],
      paymentSystemTypes: [String],
      paymentMethodTypes: [String],
      purchaseItemCategories: [String],
      purchaseItemStatuses: [String],
      periodCount: 0,
      periodType: String,
      reportId: Number,
      reportName: String,
      subscriptionsFilter: {
        names: [String],
        dailySubscriptionLength: {
          from: moment,
          to: moment
        },
        monthlySubscriptionLength: {
          from: moment,
          to: moment
        }
      },
      users: [String],
      convertedAfterTrialDays: Number,
      withoutTrial: false,
      $convertedAfterTrialDays: false,
      $bySubscription: 'Plans'
    },

    _prepare: function () {
      if (!this.subscriptionsFilter) { this.subscriptionsFilter = {} }
      if (!this.subscriptionsFilter.dailySubscriptionLength) {
        this.subscriptionsFilter.dailySubscriptionLength = {}
      }
      if (!this.subscriptionsFilter.monthlySubscriptionLength) {
        this.subscriptionsFilter.monthlySubscriptionLength = {}
      }
    },

    _object: function () {
      const ret = Entity.prototype._object.apply(this, arguments)

      if (ret.periodType === 'CUSTOM') {
        ret.from = moment(this.from).startOf('day').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
        ret.to = moment(this.to).endOf('day').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
      }

      return ret
    },

    _urlTemplate: 'api/report/transactional/{{::reportId}}',
    _publicUrlTemplate: '/report/transactional/{{::reportId}}'
  }, onOffMixin)

  ReportTransactionSeed.getSubscriptions = function () {
    return $http.get('/report/transactional/extra')
      .data()
      .then((response) => response.payload)
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  ReportTransactionSeed.search = function (url, params) {
    return $http.post(url, { ...params })
      .data()
      .then((response) => response.payload)
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  ReportTransactionSeed.extra = {
    subscriptions: [{ id: Number, name: String }]
  }

  Object.assign(ReportTransactionSeed, Entity)
  ReportTransactionSeed._name = 'Transactions Reports'
  ReportTransactionSeed.init()

  return ReportTransactionSeed
}
